import { api } from './axios';

export type AuthEventType = 'LOGIN_SUCCESS' | 'LOGIN_FAILED' | 'LOGOUT' | 'SESSION_EXPIRED';

export interface AuthEvent {
  id: number;
  username: string;
  appUserId: number | null;
  eventType: AuthEventType;
  ipAddress: string | null;
  occurredAt: string;
}

export interface AuthEventSummary {
  from: string;
  to: string;
  total: number;
  loginSuccess: number;
  loginFailed: number;
  logout: number;
  sessionExpired: number;
}

export interface PageResponse<T> {
  content: T[];
  totalElements: number;
  totalPages: number;
  number: number;   // Spring's page index field
  size: number;
}

export interface AuditEntityType {
  key: string;
  label: string;
}

export interface FieldChange {
  field: string;
  oldValue: unknown;
  newValue: unknown;
}

export interface EntityRevision {
  revision: number;
  revisionTimestamp: string;
  revisionType: 'ADD' | 'MOD' | 'DEL';
  updatedBy: number | null;
  updatedByUsername: string | null;
  snapshot: Record<string, unknown>;
  changes: FieldChange[];
}

export interface EntityHistoryResponse {
  entityType: string;
  entityId: number;
  revisions: EntityRevision[];
}

export const auditApi = {
  authEvents: (params: {
    username?: string;
    eventType?: AuthEventType;
    from?: string;
    to?: string;
    page?: number;
    size?: number;
  }) =>
    api
      .get<PageResponse<AuthEvent>>('/audit/auth-events', { params })
      .then((r) => ({
        ...r.data,
        page: r.data.number,
      })),
  authEventSummary: (from: string, to: string) =>
    api.get<AuthEventSummary>('/audit/auth-events/summary', { params: { from, to } }).then((r) => r.data),

  historyTypes: () => api.get<AuditEntityType[]>('/audit/history/types').then((r) => r.data),
  history: (entityType: string, entityId: number) =>
    api
      .get<EntityHistoryResponse>('/audit/history', { params: { type: entityType, id: entityId } })
      .then((r) => r.data),
};
